import React from 'react';
import classNames from 'classnames';

import './Popup.scss';

class Popup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  makeClose = () => {
    const { maskClosable = true } = this.props;
    if(!maskClosable) return;
    this.onClose();
  }

  onClose = () => {
    const { onClose } = this.props;
    onClose && onClose();
  }

  render() {
    const { title, visible, showClose = true, bodyClassName, className } = this.props;
    return (
      <div className={classNames(`v-popup v-popup-${visible ? 'open' : 'hide'}`, className)}>
        <div className="v-popup_overlay" onClick={this.makeClose} />
        <div className="v-popup_wrapper">
          {(title || showClose) && <div className="v-popup_header">
            <div className="v-popup_title">{title}</div>
            {showClose && <div className="v-popup_close-icon" onClick={this.onClose}>
              {/* <i className="ic ic-close" onClick={this.onClose} /> */}
            </div>}
          </div>}
          <div className={classNames('v-popup_body', bodyClassName)}>
            {this.props.children}
          </div>
          <div className="v-popup_footer" />
        </div>
      </div>
    );
  }
}

export default Popup;

